import React, {FC, PropsWithChildren} from 'react';

export interface CaseProps {
	statement: any | ((value: any) => boolean);
}

export const Case: FC<PropsWithChildren<CaseProps>> = ({statement, children, ...other}) => {
	const {value} = other as unknown as {value: any};

	if (typeof statement === 'function') return statement(value) ? <>{children}</> : null;

	return statement === value ? <>{children}</> : null;
};
